import { useLimitSummary } from 'components/common-form/sidePanel/docToolbar/summary/hooks/useLimitSummary';
import { LimitSummaryApiConnector } from 'components/common-form/sidePanel/docToolbar/summary/mailSender/MailSenderSecondary.apiconnectors';
import type { LimitSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/limitSummaryMailRequest';
import { FormattedMessage } from 'components/shared/Intl';
import { useUserNotification } from 'hooks/useUserNotification';
import { FC } from 'react';
import { lastValueFrom } from 'rxjs';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { httpClient } from 'utils/http/httpClient';

type MailSenderLimitSecondaryProps = { tabId: string; summary?: string };

export const SummaryMailSenderLimitSecondary: FC<MailSenderLimitSecondaryProps> = ({ tabId, summary }) => {
  const limitSummaryMailRequestProps: LimitSummaryMailRequest = useLimitSummary(tabId);
  const notification = useUserNotification();

  const sendLimitHtmlEmail = (): void => {
    const htmlRequest: LimitSummaryMailRequest & { summary?: string } = {
      ...limitSummaryMailRequestProps,
      summary,
    };

    lastValueFrom(LimitSummaryApiConnector(httpClient).sendMailInHtmlFormat(htmlRequest)).then(
      onMailSentWithSuccess,
      onMailSentWithError,
    );
  };

  const logAnalyticsCategory = 'Secondary market';
  const onMailSentWithError = (_: Error): void => {
    notification.error({
      title: { id: 'toast.mail' },
      content: [{ id: 'mailSentWithError' }],
      closeAutomatically: false,
    });
  };

  const onMailSentWithSuccess = (): void => {
    notification.success({ title: { id: 'toast.mail' }, content: [{ id: 'mailSentWithSuccess' }] });
  };

  const onSendToMe = (): void => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Send mail to me');
    sendLimitHtmlEmail();
  };

  return (
    <button className="btn btn-xl btn-primary" onClick={onSendToMe} data-e2e="sendToMe-secondary-product-summary">
      <FormattedMessage id="sendToMe" />
    </button>
  );
};
